<template>
	<v-container>
		<h1 class="text-center">Redirecting to new application.</h1>
	</v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapState } from 'vuex';
import { Mutation } from 'vuex-class';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ConfigVersion } from '@/api/configversion/';
import { AuthStore } from '@kasasa/fbase-components/lib';


@Component({
  computed: mapState([
    'auth',
  ]),
})
export default class IncomingRedirect extends Vue {
	@Prop() destination!:string;

	@Prop() fiId!:string;

	@Mutation('fiId') mutationFi: any;

	auth!: AuthStore;

	mounted() {
	  this.redirect();
	}

	@Watch('auth', { deep: true })
	redirect() {
	  if (this.auth && this.auth.headerData) {
	    // The router assumes that the first parameter is the client id, but really when coming
	    // from the legacy application it's the fiId, so translate it, and store the fiId
	    // in vuex
	    this.mutationFi(this.fiId);

	    const clientId:number|null = this.clientIdFromFiId(parseInt(this.fiId, 10));
	    let url:string = `/${clientId}/${this.destination}`;

	    const version = this.$route.query.version;

	    if (version) {
	      url += `?version=${version}`;
	    }

	    this.$router.replace(url);
	  }
	}

	clientIdFromFiId(fiId:number) : number|null {
	  let clientId:number|null = null;
	  if (this.auth && this.auth.headerData) {
	    for (let i:number = 0; i < this.auth.headerData.fis.length; i++) {
	      // The linter insists on '===' here but that doesn't find a match. Not sure why.
	      // Even defining fiId as number|null, the same as in the fi class, doesn't help.
	      /* eslint-disable eqeqeq */
	      if (this.auth.headerData.fis[i].fiId == fiId) {
	        /* eslint-disable eqeqeq */
	        clientId = this.auth.headerData.fis[i].id;
	        break;
	      	}
	    }
	  }
	  return clientId;
	}
}
</script>

<style lang="scss" scoped>
</style>
